import dayjs, { Dayjs } from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTime);

export interface DateRange {
  start: Dayjs;
  end: Dayjs;
}

export function getDaysBetween(start: Dayjs, end: Dayjs) {
  return dayjs(end).diff(dayjs(start), 'day');
}

export function getRangeString(startString: string, endString: string) {
  const start = dayjs(startString);
  const end = dayjs(endString);
  if (end.isSame(dayjs(), 'day')) {
    const range = getDaysBetween(start, end);
    if (range === 0) return $localize`Today`;
    return `Last ${range} day${range > 1 ? 's' : ''}`;
  }
  return $localize`From ${start.format('DD.MM.YYYY')} to ${end.format('DD.MM.YYYY')}`;
}

export default dayjs;
